.root {
  --checkbox-label-color: inherit;
  --checkbox-label-weight: 400;
  --checked-label-weight: 600;
}

.label {
  font-family: var(--mantine-font-family);
  font-size: var(--mantine-font-size-sm);
  line-height: var(--mantine-line-height-sm);
  color: var(--checkbox-label-color);
  font-weight: var(--checkbox-label-weight);
}

.root[data-variant="inherit"] .input {
  background-color: inherit;
}

.root[data-variant="inherit"]:has(.input:checked),
.root[data-variant="inherit"]:has(.input[data-checked]) {
  --checkbox-label-weight: var(--checked-label-weight);
}

.root[data-variant="outline"]:has(.input:checked),
.root[data-variant="outline"]:has(.input[data-checked]) {
  --checkbox-label-weight: var(--checked-label-weight);
}
